export function detokenizeYear(input: string): string {
    if (!input) return ''

    const year = new Date().getFullYear()
    return input.replace('#YEAR-TOKEN#', year.toString())
}
